export const AUTH_MODE = import.meta.env.VITE_AUTH_MODE || 'dev';
export const IS_KEYCLOAK_MODE = AUTH_MODE === 'keycloak';

export const keycloakConfig = {
  url: import.meta.env.VITE_KEYCLOAK_URL || 'http://localhost:8090',
  realm: import.meta.env.VITE_KEYCLOAK_REALM || 'damar-hr',
  clientId: import.meta.env.VITE_KEYCLOAK_CLIENT_ID || 'damar-hr-web',
  get tokenUrl() {
    return `${this.url}/realms/${this.realm}/protocol/openid-connect/token`;
  },
  get logoutUrl() {
    return `${this.url}/realms/${this.realm}/protocol/openid-connect/logout`;
  },
};

// Token refresh at 80% of lifetime
export const TOKEN_REFRESH_THRESHOLD = 0.8;
export const MAX_RETRY_DELAY = 30_000;

export interface JwtUser {
  sub: string;
  email: string;
  preferred_username: string;
  given_name: string;
  family_name: string;
  tenant_id: string;
  realm_roles: string[];
  groups: string[];
  locale: string;
  email_verified: boolean;
  name: string;
}

export function decodeJwt(token: string): JwtUser {
  const payload = token.split('.')[1];
  return JSON.parse(atob(payload));
}
